import React from 'react';
import {connect} from 'react-redux';
import {Dimmer, Loader} from 'semantic-ui-react';
import {Redirect} from 'react-router-dom';
import _ from 'lodash';

import REST from 'go/requests/rest';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import {ContentDispatch} from 'framework';
import Error from 'app-ui-componentlibrary/dist/go/components/common/error';
import NetworkErrorModal from 'go/components/dynamic/common/modals/NetworkErrorModal';
import {
  compileContent,
  getTimestampNowISO,
  isFemaUser,
  countDependenciesToLoad,
  checkActivityCompleted,
  checkAndHandleEntityStatusSync,
  getSubOrganizationId,
} from 'common/utils';
import {Contexts} from 'componentLibrary';
import {ADD_MSG} from 'common/types';
import {
  ACTIVITY_RESPONSES,
  STATUS_PENDING_SUBMISSION,
  STATUS_PENDING_AOR_SIGNATURE,
  STATUS_PENDING_SAR_SIGNATURE,
  STATUS_RETURNED_TO_RECIPIENT,
  STATUS_SUBMITTED_TO_RECIPIENT,
  STATUS_NOT_SUBMITTED,
  STATUS_SUBMITTED_TO_FEMA,
  PROGRAM_TYPE_PASSTHROUGH,
} from 'app-ui-componentlibrary/dist/common/constants';
import {produce} from 'immer';
import {HOME} from 'app-ui-componentlibrary/dist/go/components/common/pageTitles';
import {canViewPostAwardEntities} from 'go/security/permissions';
import {connectWithCore} from 'framework/hocs';
import CollaborationActions from 'go/actions/api/collaboration';
import {EXCLUDEDFOS} from 'common/requestDetails/constants.js';
import grant from 'go/actions/api/grant';

const {SubmitContext} = Contexts;

export const statusForEdit = (status) => {
  return (
    status === STATUS_PENDING_SUBMISSION ||
    status === STATUS_RETURNED_TO_RECIPIENT ||
    status === STATUS_SUBMITTED_TO_RECIPIENT
  );
};

export class EntityPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      submitting: false,
      error: false,
      redirect: false,
    };
  }

  componentDidMount() {
    let subtitles = {
      application: 'Application',
      subApplication: 'Sub Application',
      payment: 'Payment',
      amendment: 'Amendment',
      returnOfFund: 'Return of Fund',
      subAmendmentRecommendation: ' Subamendment',
      financialReport: 'Financial Report',
      bsirReport: 'Biannual Strategy Implementation Report',
      performanceProgressReport: 'Performance Progress Report',
      closeoutReport: 'Closeout Report',
      subCloseoutReport: 'Subgrant Closeout Report',
      rfi: 'Request for Information',
      fundingOpportunity: 'Funding Opportunity',
      allocation: 'Allocation',
      rfa: 'Request for Assistance',
      fundingOpportunityDraft: 'Funding Opportunity Draft',
      ehpReview: 'EHP compliance review outcome',
      propertyData: 'Property Data Mitigation',
    };
    let title = '- ' + subtitles[this.props.entityType] || '';

    document.title = HOME + ' ' + title;

    let {
      token,
      match,
      entityType,
      configType,
      toggles: {toggles},
    } = this.props;
    let entityId = _.get(match, 'params.entityId');

    const subrecipientReviewPanelToggle = _.includes(toggles, 'GMMGO-12948');

    let entityApiCall;

    if (entityType == 'fundingOpportunity') {
      entityApiCall = REST.fundingOpportunity.getFundingOpportunity;
    } else if (entityType == 'allocation') {
      entityApiCall = REST.allocation.getAllocation;
    } else if (entityType == 'fundingOpportunityDraft') {
      entityApiCall = REST.fundingOpportunityDraft.getFundingOpportunityDraft;
    } else if (entityType == 'ehpReview') {
      entityApiCall = REST.ehp.getReviewById;
    } else {
      entityApiCall = REST.dynamicData.getEntityById;
    }

    if (entityId) {
      return entityApiCall(token, entityId)
        .then(REST.handler.handleResponse)
        .then(async (entityData) => {
          let subGrantData;
          if (entityType === 'ehpReview') {
            subGrantData = await REST.dynamicData
              .getEntityById(token, _.get(entityData, 'reviewStatus.projectId', ''))
              .then(REST.handler.handleResponse);
          }

          if (
            entityType == 'fundingOpportunity' ||
            entityType == 'allocation' ||
            entityType == 'fundingOpportunityDraft'
          ) {
            entityData.entityType = entityType;
          }
          const {
            entityType: dataEntityType,
            fundingOpportunityId,
            categoryId,
            status,
            entityId,
            fundingOpportunity,
            entitySubType,
          } = entityData;

          if (
            configType !== 'entityView' &&
            (status === STATUS_PENDING_AOR_SIGNATURE ||
              status === STATUS_NOT_SUBMITTED ||
              status === STATUS_PENDING_SAR_SIGNATURE ||
              status === STATUS_SUBMITTED_TO_RECIPIENT)
          ) {
            this.props.history.push(`/${entityType}/${entityId}/view`);
          } else if (configType !== 'entityEdit' || statusForEdit(status)) {
            if (
              dataEntityType === entityType ||
              (entityType === 'ehpReview' && entityData)
            ) {
              let type = 'fo';
              let id =
                entityType === 'ehpReview'
                  ? _.get(subGrantData, 'fundingOpportunityId')
                  : fundingOpportunityId;
              if (entityType === 'subApplication' && fundingOpportunityId === undefined) {
                type = 'pc';
                id = categoryId;
              }
              let permission = this.props.auth.permissions;

              if (
                configType === 'entityView' &&
                entityType === 'subAmendmentRecommendation' &&
                _.get(entityData, 'payload.amendmentId') &&
                canViewPostAwardEntities(permission)
              ) {
                return Promise.reject(
                  `${_.upperFirst(
                    entityType
                  )} page error: Only accessible to internal users for this program.`
                );
              }

              return this.fetchConfig(id, type, entitySubType).then((config) => {
                return this.initializeReduxState(config, entityData);
              });
            } else {
              return Promise.reject(
                `${_.upperFirst(
                  entityType
                )} page error: Found entity of incorrect entity type.`
              );
            }
          } else if (
            entityType === 'application' &&
            configType === 'entityEdit' &&
            status === STATUS_SUBMITTED_TO_FEMA &&
            _.get(entityData, 'payload.programType') === PROGRAM_TYPE_PASSTHROUGH
          ) {
            return this.fetchConfig(fundingOpportunityId, 'fo').then((config) => {
              return this.initializeReduxState(config, entityData);
            });
          } else if (
            entityType === 'fundingOpportunityDraft' &&
            configType === 'entityEdit'
          ) {
            let params = entityData.payload?.isUpdate
              ? `foUpdate=true&cacheKey=draft-${entityData.draftId}-update`
              : 'foUpdate=false';
            return this.fetchConfig(0, 'passthrough', null, params).then((config) => {
              return this.initializeReduxState(config, entityData);
            });
          } else {
            return Promise.reject(
              `${_.upperFirst(
                entityType
              )} page error: Found entity with uneditable status.`
            );
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            loading: false,
            error: true,
          });
        });
    } else {
      this.setState({
        loading: false,
        error: true,
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {data, config, userId, token, location, match} = this.props;
    const {
      data: nextData,
      config: nextConfig,
      userId: nextUserId,
      location: nextLocation,
      match: nextMatch,
    } = nextProps;

    const equalUrl =
      _.get(match, 'params.entityId') === _.get(nextMatch, 'params.entityId');
    const equalLocation = location === nextLocation;
    const configChanged =
      (config === undefined && nextConfig !== undefined) ||
      _.get(config, 'configId') !== _.get(nextConfig, 'configId');
    const equalUserId = userId === nextUserId;
    const equalState = _.isEqual(this.state, nextState);

    const shouldUpdate =
      !(
        equalUrl &&
        equalUserId &&
        equalLocation &&
        equalState &&
        _.isEqual(_.get(data, 'grantId'), _.get(nextData, 'grantId'))
      ) || configChanged;

    return shouldUpdate;
  }

  static getDerivedStateFromProps(props, state) {
    const dependencies = _.get(props, 'config.dependencies');
    const toggles = _.get(props, 'toggles.toggles');
    const dependenciesToLoad = countDependenciesToLoad(
      dependencies,
      isFemaUser(_.get(state, 'auth.permissions')),
      toggles,
      'fundingOpportunityId',
      _.get(props, 'fundingOpportunityId')
    );
    if (
      state.loading &&
      state.initialized &&
      props.numLoadedSuccessfully >= dependenciesToLoad
    ) {
      return {
        ...state,
        loading: false,
      };
    }
    return null;
  }

  fetchConfig = (fundingOpportunityId, type, entitySubType, params) => {
    const {token, configType, entityType: configId} = this.props;

    const apiCall = params
      ? REST.config.getConfigurationWithParams
      : REST.config.getConfiguration;

    return apiCall(
      token,
      type,
      fundingOpportunityId,
      configType,
      entitySubType && entitySubType != 'null'
        ? `${configId}_${entitySubType}`
        : configId,
      params
    ).then(REST.handler.handleResponse);
  };

  initializeReduxState = (config, entityData) => {
    const {init, auth, toggles, profile, message} = this.props;

    init({
      config,
      data: entityData,
      context: {
        auth,
        toggles,
        profile,
      },
      validations: {},
    });
    this.setState({initialized: true});
    {
      /* hack when submitting an entity from femago-ui, the message needs to be displayed */
    }
    if (message !== undefined) {
      this.props.addMessage(message);
    }
  };

  handleSubmit = async (submitPayload = {}, password, snapshotOnly) => {
    let {
      token,
      data,
      userId,
      config,
      organizationName,
      organizationState,
      region,
      fundingOpportunityNumber,
      fundingOpportunityName,
      saveEntitySessionData,
      currentlyCollaborating,
    } = this.props;

    if (submitPayload.skipWorkflow) {
      return await REST[submitPayload.service]
        [submitPayload.action](token, submitPayload.programId, submitPayload.draftId)
        .then((res) => {
          return REST.handler.handleResponse(res).then((json) => {
            if (submitPayload.response) {
              saveEntitySessionData(
                `data.${submitPayload.response}`,
                json[submitPayload.response]
              );
              this.setState({
                redirect: true,
              });
            } else {
              this.setState({redirect: true});
            }
            return res;
          });
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            error: true,
          });
          return err;
        });
    }

    const topLevelParams = {
      organizationId: data.organizationId,
      grantId: data.grantId,
      fundingOpportunityId: data.fundingOpportunityId,
      programId: data.programId,
      allocationId: data.sysAllocationId,
    };

    if (data.entityType === 'subApplication') {
      topLevelParams.entityId = data.entityId;
      topLevelParams.entityType = data.entityType;
      topLevelParams.subOrgId = getSubOrganizationId(data);
      const isPassthrough =
        data.payload.programType && data.payload.programType === PROGRAM_TYPE_PASSTHROUGH;
      topLevelParams.contextId = isPassthrough
        ? parseInt(data.fundingOpportunityId)
        : parseInt(data.categoryId);
      topLevelParams.contextType = isPassthrough ? 'fo' : 'pc';
      topLevelParams.applicationTitle = data.payload.applicationTitle;
    }

    const startingProcessVariables = {
      entityId: data.entityId,
      submittedUserId: userId,
      submittedTimestamp: getTimestampNowISO(),
      entityNumber: data.entityNumber,
      organizationId: data.organizationId,
      organizationName,
      organizationState,
      region,
      fundingOpportunityNumber,
      fundingOpportunityName,
      ...topLevelParams,
      ...submitPayload,
    };
    let snapshotData = produce(data, (draft) => {
      _.set(draft, 'id', data.entityId);
    });

    if (snapshotOnly) {
      return REST.snapshot
        .postSnapshot(token, snapshotData)
        .then(REST.handler.handleResponse);
    }

    this.setState({submitting: true});

    return REST.snapshot
      .postSnapshot(token, snapshotData)
      .then(REST.handler.handleResponse)
      .then((res) => {
        return REST.workflow.startProcess(
          token,
          config.processToStart,
          password,
          topLevelParams,
          startingProcessVariables
        );
      })
      .then((res) => {
        if (_.get(res, 'status') === 403) {
          currentlyCollaborating && this.handleSubmissionUnlock();
          this.setState({submitting: false});
          return res;
        } else {
          return REST.handler.handleResponse(res).then((json) => {
            if (json.errors) {
              currentlyCollaborating && this.handleSubmissionUnlock();
              this.setState({submitting: false});
              res.errors = _.flatMap(json.errors);
              return res;
            } else {
              const {activityToWaitFor, expectedStatus} = config;

              if (activityToWaitFor) {
                return checkActivityCompleted({
                  token: token,
                  processInstanceId: json.processInstanceId,
                  activityId: activityToWaitFor,
                  activityResponse: ACTIVITY_RESPONSES.ended,
                  callback: () => {
                    const entityStatusRedux = data.status;
                    const entityStatusWorkflow =
                      expectedStatus || STATUS_SUBMITTED_TO_FEMA;
                    let {token, match} = this.props;
                    let entityId = _.get(match, 'params.entityId');

                    if (entityStatusRedux != entityStatusWorkflow) {
                      return checkAndHandleEntityStatusSync(
                        token,
                        entityId,
                        entityStatusWorkflow,
                        () => {
                          this.setState({redirect: true});
                          return res;
                        }
                      );
                    } else {
                      this.setState({redirect: true});
                      return res;
                    }
                  },
                });
              } else {
                this.setState({redirect: true});
                return res;
              }
            }
          });
        }
      })
      .catch((err) => {
        console.error('error');
        this.setState({
          error: true,
        });
        currentlyCollaborating && this.handleSubmissionUnlock();
        return err;
      });
  };

  handleSubmissionLock = () => {
    let {data, userId, collaborativeSubmissionLock} = this.props;
    collaborativeSubmissionLock(
      userId,
      data.entityId,
      data.entityType,
      data.grantId,
      data.subGrantId
    );
  };

  handleSubmissionUnlock = () => {
    let {data, collaborativeSubmissionUnlock} = this.props;
    collaborativeSubmissionUnlock(data.entityId);
  };

  handlePostSubmit = () => {
    const {config} = this.props;
    this.props.addMessage(_.get(config, 'rerouteMessage'));
  };

  handleErrorConfirmation = (networkErrorEntityErrors) => {
    this.props.history.push('/redirecting_page');
    this.props.clear().then(() => {
      if (_.get(networkErrorEntityErrors, 'redirect')) {
        this.props.history.push(`/grant/${networkErrorEntityErrors.grantId}`);
      } else {
        this.props.history.replace(this.props.routerLocation);
      }
    });
  };

  render() {
    let {config, location, data} = this.props;
    let grantId = _.get(data, 'grantId', '');
    let fundingOpportunitySave = _.get(data, 'savedFundingOpportunityId', '');
    let {error, redirect, loading, submitting} = this.state;
    const rerouteOnSubmit = _.get(config, 'rerouteOnSubmit');

    const submitContext = {
      handleSubmit: this.handleSubmit,
      handlePostSubmit: this.handlePostSubmit,
      handleSubmissionLock: this.handleSubmissionLock,
      handleSubmissionUnlock: this.handleSubmissionUnlock,
    };

    const listeners = _.get(config, 'listeners', []);
    const contents = _.get(config, 'contents', []);

    return (
      <React.Fragment>
        {error && <Error />}
        {redirect && (
          <Redirect
            push
            to={
              rerouteOnSubmit
                ? fundingOpportunitySave
                  ? compileContent(rerouteOnSubmit, data)
                  : compileContent(rerouteOnSubmit, this.props)
                : `/grant/${grantId}`
            }
          />
        )}
        {loading && <Loader active>Loading...</Loader>}
        <NetworkErrorModal
          networkErrorPath="saveEntitySaga"
          handleErrorConfirmation={this.handleErrorConfirmation}
        />
        {!loading && !error && !redirect && (
          <React.Fragment>
            {submitting && (
              <Dimmer active>
                <Loader />
              </Dimmer>
            )}
            {_.map(listeners, (listenerConfig, index) => (
              <ContentDispatch config={listenerConfig} key={index} />
            ))}
            <SubmitContext.Provider value={submitContext}>
              {_.map(contents, (itemConfig, index) => (
                <ContentDispatch
                  key={itemConfig.type + index}
                  config={itemConfig}
                  currentLocation={location}
                />
              ))}
            </SubmitContext.Provider>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const addMessage = (dispatch) => {
  return (msg) =>
    dispatch({
      type: ADD_MSG,
      msg: msg,
    });
};

export const mapDispatchToProps = (dispatch) => ({
  init: (initState) => dispatch(CollaborationActions.initWithStateProxy(initState)),
  clear: () => {
    return new Promise((resolve, reject) => {
      dispatch(DynamicComponentActions.clearDynamicComponent({}));
      resolve();
    });
  },
  addMessage: addMessage(dispatch),
  collaborativeSubmissionLock: (who, entityId, entityType, grantId, subGrantId) => {
    dispatch(
      CollaborationActions.submissionLock({
        who,
        entityId,
        entityType,
        grantId,
        subGrantId,
      })
    );
  },
  collaborativeSubmissionUnlock: (entityId) => {
    dispatch(CollaborationActions.submissionUnlock({entityId}));
  },
});

export const mapStateToProps = (state) => {
  const currentLocation = _.get(state, 'dynamicComponent.currentLocation');

  return {
    auth: state.auth,
    profile: state.profile,
    toggles: state.toggles,
    token: state.auth.token,
    location: currentLocation === '' ? 'contents[0]' : currentLocation,
    routerLocation: _.get(state, 'router.location.pathname'),
    config: _.get(state, 'dynamicComponent.config'),
    data: _.get(state, 'dynamicComponent.data'),
    userId: state.auth.userId,
    numLoadedSuccessfully: _.get(state, 'dynamicComponent.context.numLoadedSuccessfully'),
    organizationName: _.get(state, 'dynamicComponent.context.organization.displayName'),
    organizationState: _.get(
      state,
      'dynamicComponent.context.organization.physicalAddress.stateOrProvince'
    ),
    region: _.get(state, 'dynamicComponent.context.organization.region'),
    fundingOpportunityNumber: _.get(
      state,
      'dynamicComponent.context.fundingOpportunityData.fundingOpportunityNr'
    ),
    fundingOpportunityName: _.get(
      state,
      'dynamicComponent.context.fundingOpportunityData.fundingOpportunityName'
    ),
    fundingOpportunityId: _.get(state, 'dynamicComponent.data.fundingOpportunityId'),
    allocationId: _.get(state, 'dynamicComponent.data.sysAllocationId'),
    currentlyCollaborating: !!_.get(state, 'dynamicComponent.collaboration.roomList', ''),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(connectWithCore(EntityPage));
